<template>
  <a-drawer
    :title="modalFlag === 1 ? '详情' : modalFlag === 2 ? '编辑' : '添加'"
    :width="drawerWidth"
    @close="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :wrapStyle="{height: '100%',overflow: 'auto'}"
  >
    <div :style="{width: '100%',border: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',}">
      <a-spin :spinning="confirmLoading">
        
        <a-form :form="form">
          <a-form-item
            v-bind="formItemLayout"
            label="登入名"
          >
            <a-input
              v-decorator="[
                'userId',
                {
                  rules: [{ required: true, message: '请输入您的登入名' }],
                  initialValue: user.userId
                }
              ]"
            />
          </a-form-item>

          <a-form-item
            v-if="modalFlag === 3"
            v-bind="formItemLayout"
            label="密码"
          >
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: '请输入登陆密码' },
                    { validator: validateToNextPassword },
                    { validator: validateSimpePassword }
                  ],
                  initialValue: user.password
                }
              ]"
              type="password"
            />
          </a-form-item>

          <a-form-item
            v-if="modalFlag === 3"
            v-bind="formItemLayout"
            label="确认密码"
          >
            <a-input
              v-decorator="[
                'confirm',
                {
                  rules: [
                    { required: true, message: '请重新输入登陆密码' },
                    { validator: compareToFirstPassword }
                  ],
                  initialValue: user.password
                }
              ]"
              type="password"
              @blur="handleConfirmBlur"
            />
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="姓名"
          >
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '请输入姓名' }],
                  initialValue: user.name
                }
              ]"
            />
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="英文名"
          >
            <a-input v-decorator="['englishName',{ initialValue: user.englishName }]" />
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="角色"
          >
            <a-select
                mode="multiple"
                v-decorator="['sysRoleIds',{ initialValue: user.sysRoleIds || [] }]"
            >
                <a-select-option v-for="item in rolelist" :key="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>


          <a-form-item
            v-bind="formItemLayout"
            label="部门"
          >
            <a-tree-select
              v-decorator="[
                'selectedDeployment',
                {
                  rules: [{ required: true, message: '请选择部门' }],
                  initialValue: selectedDeployment
                }
              ]"
              showSearch
              :value="selectedDeployment"
              labelInValue
              :treeData="departmentTree"
              :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
              allowClear
              treeNodeFilterProp="title"
              treeDefaultExpandAll
              @change="onChangeDep"
            >
            </a-tree-select>
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="岗位"
          >
            <a-input v-decorator="['position',{ initialValue: user.position }]" />
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="性别"
          >
            <a-select
              v-decorator="[
                'gender',
                {
                  rules: [{
                    message: '请选择性别'
                  }],
                  initialValue: user.gender ? user.gender + '' : ''
                }
              ]"
            >
              <a-select-option value="1">
                男
              </a-select-option>
              <a-select-option value="2">
                女
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="联系号码"
          >
            <a-input
              v-decorator="[
                'mobile',
                {
                  rules: [{
                    type: 'number',
                    transform(value) {
                      if(value){
                        return Number(value);
                      }
                    },
                    message: '请输入数字号码'
                  }],
                  initialValue: user.mobile
                }
              ]"
            />
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            label="邮箱"
          >
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [{ type: 'email', message: '请输入正确的邮箱地址' }],
                  validateTrigger: ['blur'],
                  initialValue: user.email
                }
              ]"
            />
          </a-form-item>

          <a-form-item label="是否领导"  v-bind="formItemLayout">
            <a-radio-group v-decorator="['isLeaderInDept', { initialValue: user.isLeaderInDept }]">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-item>

    </a-form>

      </a-spin>
      <a-row :style="{textAlign:'right'}">
        <a-button :style="{marginRight: '8px'}" @click="handleCancel">
          关闭
        </a-button>
        <a-button @click="handleOk" type="primary">确定</a-button>
      </a-row>
    </div>
  </a-drawer>
</template>

<script>
import { addUser, updateUser } from '@/baseAPI/user'

export default {
  name: 'UserModal',
  data () {
    return {
      drawerWidth: 700,
      visible: false,
      form: this.$form.createForm(this),
      modalFlag: 0,
      confirmLoading: false,
      confirmDirty: false,
      user: {},
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      selectedDeployment: {}
    }
  },
  props:{
    departmentTree: Array,
    rolelist: Array
  },
  mounted: function () {
  },
  methods: {
    show (modalFlag, user) {
      this.form.resetFields()
      this.resetScreenSize() // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.modalFlag = modalFlag
      this.user = user
      this.selectedDeployment = {}
      if (this.user.orgCode) {
        this.selectedDeployment.value = this.user.orgCode
        this.selectedDeployment.label = this.user.orgName
      }
      this.visible = true
    },
    handleCancel () {
      this.$emit('ok')
      this.visible = false
    },
    handleOk () {
      if (this.modalFlag === 1) {
        this.visible = false
        return
      }
      const _this = this
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.$confirm({
            title: '确认操作',
            content: this.modalFlag === 2 ? '是否编辑用户?' : '是否添加用户?',
            okText: '确认',
            cancelText: '取消',
            onOk: function () {
              const values = {
                ...fieldsValue,
                'orgCode': _this.selectedDeployment.value || '',
                'orgName': _this.selectedDeployment.label || '',
              }
              _this.confirmLoading = true

              if (_this.modalFlag === 2) {
                updateUser(values)
                  .then(res => {
                    if(res.data.success){
                      _this.$notification.success({
                        message: '提示',
                        description: res.message || '编辑用户成功',
                        duration: 3
                      })
                      _this.form.resetFields()
                      _this.handleCancel()
                    } else {
                      _this.$notification.error({
                        message: '错误',
                        description: res.data.errorMessage || '编辑用户失败',
                        duration: 3
                      })
                    }
                  })
                  .catch(err => {
                    console.log('err:', err.response)
                    _this.$notification.error({
                      message: '错误',
                      description: ((err.response || {}).data || {}).message || '编辑用户失败',
                      duration: 3
                    })
                  })
              } else if (_this.modalFlag === 3) {
                addUser(values)
                  .then(res => {
                    if(res.data.success){
                      _this.$notification.success({
                        message: '提示',
                        description: res.message || '添加用户成功',
                        duration: 3
                      })
                      _this.form.resetFields()
                      _this.handleCancel()
                    } else {
                      _this.$notification.error({
                        message: '错误',
                        description: res.data.errorMessage || '添加用户失败',
                        duration: 3
                      })
                    }
                  })
                  .catch(err => {
                    console.log('err:', err.response)
                    _this.$notification.error({
                      message: '错误',
                      description: ((err.response || {}).data || {}).message || '添加用户失败',
                      duration: 3
                    })
                  })
              }
              _this.confirmLoading = false
            }
          })
        }
      })
    },
    handleConfirmBlur  (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword  (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    validateSimpePassword (rule, value, callback) {
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,16}$/;
      if (value && !pattern.test(value)) {
        callback(new Error('密码长度8-16，必须包含大写字母、小写字母、数字、特殊字符:!@#$%^&*()'))
      } else {
        callback()
      }
    },
    onChangeDep (value) {
      this.selectedDeployment = value
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize () {
      const screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth
      } else {
        this.drawerWidth = 700
      }
    },
  }
}
</script>
